export const checkIfProIncluded = (params) => {
  const excludedPros = params.api.excludedPros;
  return !excludedPros?.has(params.data.proId);
};

export const handleCheckboxToggle = (params, isChecked) => {
  params.api.toggleExcludedPro?.(params.data.proId, isChecked);
};

export const CheckIfAllProIncluded = (params) => {
  const excludedPros = params.api.excludedPros;

  if (!excludedPros || excludedPros.size === 0) {
    return true; // If no exclusions, all are included
  }
  let allIncluded = true;

  params.api.forEachNode((node) => {
    if (excludedPros.has(node.data.proId)) {
      allIncluded = false; // Found an excluded pro
    }
  });
  return allIncluded;
};

export const handleCheckboxToggleForAll = (params, isChecked) => {
  if (!params.api.toggleExcludedPro) return;

  params.api.forEachNode((node) => {
    params.api.toggleExcludedPro(node.data.proId, isChecked);
  });
};

export const checkIsNotModified = (params) => {
  const updatedPros = params.api?.updatedPros;
  const proId = params.data?.proId;

  return !updatedPros?.has(proId);
};
